import { z } from 'zod';

import { emailSchema } from '@paid-ui/schemas/zod/email';

export const forgotPasswordSchema = z.object({
  account: emailSchema,
});

export type ForgotPasswordFormValues = z.infer<typeof forgotPasswordSchema>;
